/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { handbookHelpersList } from '../fn/helpers/handbook-helpers-list';
import { HandbookHelpersList$Params } from '../fn/helpers/handbook-helpers-list';
import { BackendHelperDto } from '../models/backend-helper-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiHelpersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `handbookHelpersList()` */
  static readonly HandbookHelpersListPath = '/api/handbook/helpers/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `handbookHelpersList()` instead.
   *
   * This method doesn't expect any request body.
   */
  handbookHelpersList$Response(
    params?: HandbookHelpersList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendHelperDto>>> {
    return handbookHelpersList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `handbookHelpersList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  handbookHelpersList(params?: HandbookHelpersList$Params, context?: HttpContext): Observable<Array<BackendHelperDto>> {
    return this.handbookHelpersList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendHelperDto>>): Array<BackendHelperDto> => r.body),
    );
  }
}
